import { maxMbSize } from "@/lib/calendesk-js-library/forms/validators";

// What the API stores (MediaController::uploadRules: jpg, jpeg, png, gif, bmp, webp; an SVG is
// refused). The browser leaves `type` empty for some files, so the extension is the fallback.
const IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/bmp",
];
// For the file picker: listing exact types (not image/*) also makes iOS hand over a JPEG
// copy of a HEIC photo.
export const IMAGE_ACCEPT = IMAGE_TYPES.join(",");

const IMAGE_EXTENSIONS = /\.(jpe?g|png|gif|webp|bmp)$/i;

export const MAX_IMAGE_MB = 10;

export function isUploadableImage(file, maxSizeInMb = MAX_IMAGE_MB) {
  if (!file || !maxMbSize(file, maxSizeInMb)) {
    return false;
  }

  return file.type
    ? IMAGE_TYPES.includes(file.type)
    : IMAGE_EXTENSIONS.test(file.name || "");
}

// The API refused the file itself (format, size or pixel dimensions), not the request.
export function isImageRefused(error) {
  return (
    error?.response?.status === 422 && !!error.response.data?.errors?.image
  );
}
